/* eslint-disable react/no-array-index-key */
import React from 'react';
import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import Common from '../Common/Common';
import bgImage from '../../Assets/elvotaimages/Group100.png';

export default function Values() {
  const contentValues = [
    {
      heading: 'Baseline First',
      paragraph:
        'We prioritize stability by first capturing the reliable value in core market dynamics, creating a strong foundation for sustainable growth.',
    },
    {
      heading: 'Strategic Intelligence',
      paragraph:
        'Technology enhances our execution, efficiency, and scalability, but every move is guided by deliberate strategy, ensuring that innovation always serves clear, long-term objectives.',
    },
    {
      heading: 'Trust and Transparency',
      paragraph:
        'Every decision is transparent and accountable. We stand by the outcomes we deliver, always optimizing for the long-term trust of asset owners rather than chasing short-term volatility.',
    },
    {
      heading: 'Commitment to Sustainability',
      paragraph:
        'We are dedicated to creating a greener future by optimizing energy storage solutions that reduce carbon footprints and promote renewable energy usage.'
    },
  ];

  const summaryContent = [
    'Harnessing the limitless power of technological evolution, we envision a future where energy storage systems seamlessly integrate with renewable sources, playing a pivotal role in a green and sustainable world.',
    'Every watt, every volt, and every electron, efficiently stored and utilized, drives us closer to an era of clean energy dominance.',
  ];

  return (
    <div>
      <Heading content="Our vision and core values" />

      {/* Summary Section */}
      <div className="pb-[40px]">
        <Summary paragraph={summaryContent} />
      </div>

      {/* Content Section */}
      <div
        className="relative z-0" // Make sure the div is positioned relatively
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain', // Ensure the image is fully contained within the section
          backgroundPosition: 'center', // Center the image
          backgroundRepeat: 'no-repeat', // Prevent image from repeating
          padding: '40px 0', // Add padding for spacing
        }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-12 lg:gap-16">
          {contentValues.map((value, index) => (
            <div key={index} className="flex h-full relative z-10">
              <Common
                heading={value.heading}
                paragraph={value.paragraph}
                imageSrc={null}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
